import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { finalize, map, Observable, Subject, take, takeUntil } from 'rxjs';
import { Rekbot } from '../../models/rekbot.model';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { NotificationService } from '../../services/notification.service';
import { RekbotsService } from '../../services/rekbots.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from "@angular/material/divider";
import { Title } from '@angular/platform-browser';
import { RekbotStateService } from './rekbot-layout-services/rekbot-state.service';
import { AuthService } from '../../services/auth.service';
import { ROLES } from '../../constants/roles.constants';

interface TabButton {
  label: string;
  route?: string;
  action?: () => void;
  exact?: boolean;
  permission?: boolean;
}

@Component({
  selector: 'app-rekbot-layout',
  imports: [
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatDivider,
    CommonModule
],
  templateUrl: './rekbot-layout.component.html',
  styleUrl: './rekbot-layout.component.css'
})
export class RekbotLayoutComponent implements OnInit, OnDestroy{

  rekbot!:Rekbot

  private destory$ = new Subject<void>();

  constructor(
    readonly activatedRoute:ActivatedRoute,
    readonly router: Router,
    private notificationService: NotificationService,
    private rekbotsService: RekbotsService,
    private title: Title,
    private rekbotStateService: RekbotStateService,
    private authService: AuthService,
  ){}

  // Uprawnienia do dostępu do ścieżek ustawień rekbota
  private canAccessSettings: boolean = this.authService.user!.role!.role_id >= ROLES.admin;;

  // możliwe ścieżki 
  buttons: TabButton[] = [
  {
    label: 'Informacje',
    route: './',
    exact: true,
    permission: true,
  },
  {
    label: 'Edytuj',
    route: 'edit',
    permission: this.canAccessSettings,
  },
  {
    label: 'Mapa',
    route: 'location',
    permission: true,
  },
  {
    label: 'Pobierz lokalizację',
    action: () => this.decodeLocationData(),
    permission: this.canAccessSettings,
  },
  {
    label: 'Ustawienia',
    route: 'settings',
    permission: this.canAccessSettings,
  },
  {
    label: 'Konfiguracja Email',
    route: 'email-config-list',
    permission: this.canAccessSettings,
  },
  {
    label: 'Notatki i wpisy',
    route: 'notes',
    permission: this.canAccessSettings,
  },
];

  ngOnInit(): void {
    // console.log("Komponent layout zainicowany");
    
    this.activatedRoute.data.pipe(take(1))
    .subscribe({
      next: data => {
        console.log("Data z komponentu layout",data['rekbot_data']);
        this.rekbotStateService.setRekbot(data['rekbot_data'].rekbot_res.rekbot);
        this.rekbotStateService.setSettings(data['rekbot_data'].settings_res.settings);
        this.rekbotStateService.setOpenHours(data['rekbot_data'].settings_res.openHours);
        this.rekbot = this.rekbotStateService.rekbot;
        this.title.setTitle(this.rekbot.serial_no);
        console.log("rekbot z serwisu: ",this.rekbot);
      }
    })
    
  }

  ngOnDestroy(): void {
    this.destory$.next();
    this.destory$.complete();
  }

  decodeLocationData() {
    
    if (this.rekbot !== undefined) {
      this.rekbotsService.decodeLocationData(this.rekbot.id)
        .subscribe({
          next: (response: any) => {
            console.log("decodeLocationData", response)

            if (response.error !== undefined) {
              this.notificationService.pushNotification(
                response.error, 'error', 5000);
            } else {
              this.notificationService.pushNotification(
                `Lokalizacja zdekodowana`, 'info', 5000);
            }
          },
          error: (error) => {
            console.log("decodeLocationData error", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        });
    }
  
  }
}
